export default __webpack_public_path__ + "static/9-neon-sign-dc44a5fb00259629729f80a812280df1.png";